module.exports = __webpack_public_path__ + "static/media/project1.5aa76f27.jpeg";